const createArrayFromRange = (start, end) => {
  return Array(end - start + 1)
    .fill()
    .map((item, index) => start + index)
}

export default createArrayFromRange
